import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { GenericCrudService } from '../../../../../services/generic-crud.service';

@Component({
  selector: 'app-movement-details',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './movement-details.component.html',
  styleUrl: './movement-details.component.css'
})
export class MovementDetailsComponent implements OnInit {
  movementId!: number;
  movement: any = null;
  loading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private genericCrudService: GenericCrudService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.movementId = +params['id'];
      this.loadMovementDetails();
    });
  }

  loadMovementDetails(): void {
    this.loading = true;
    this.genericCrudService.list(`/movement/show/${this.movementId}`).subscribe({
      next: (response) => {
        this.movement = response.data;
        this.loading = false;
      },
      error: (error: any) => {
        console.error('Error al cargar movimiento:', error);
        this.loading = false;
      }
    });
  }

  getTypeLabel(type: string): string {
    const types: any = {
      'income': 'Ingreso',
      'expense': 'Gasto',
      'transfer': 'Transferencia'
    };
    return types[type] || type;
  }

  getTypeColor(type: string): string {
    const colors: any = {
      'income': 'text-green-600',
      'expense': 'text-red-600',
      'transfer': 'text-blue-600'
    };
    return colors[type] || 'text-gray-600';
  }
}
